import React from 'react';
import { FulfillmentOrderErrorLogListTemplate } from 'themes/modules/order/pages';

function FulfillmentOrderErrorLogList(props) {
	return <FulfillmentOrderErrorLogListTemplate {...props} />;
}

export default FulfillmentOrderErrorLogList;



// WEBPACK FOOTER //
// ./src/modules/order/pages/FulfillmentOrderErrorLogList.jsx